import React from 'react'

function Loader() {
    return (
        <div className="loader-text"> </div>
    )
}

export default Loader
